import React, { useState, useContext } from 'react';
import { Box, Button, Card, CardContent, Typography, LinearProgress } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Mdplaceholder from '../../../assets/images/placeholder/Mdplaceholder.png';
import TablePagination from '@mui/material/TablePagination';
// Context
import { useMdProfileContext } from '../context/useMdProfileContext';

export default function MDGrid() {
  const { mdList, handleViewProfile } = useContext(useMdProfileContext);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      {mdList?.loading ? (
        <LinearProgress />
      ) : (
        <Grid container spacing={2}>
          <Grid item sm={12} md={12} lg={12} xl={12}>
            <Typography variant='h6' gutterBottom>
              No. of Doctor(s): {mdList?.data?.length ?? 0}
            </Typography>
          </Grid>
          {mdList.data?.length > 0 ? (
            <>
              {mdList.data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <Grid item sm={12} md={12} lg={4} xl={4}>
                    <Card
                      sx={{
                        minWidth: 275,
                        backgroundColor: '#f0f3eb',
                        borderLeft: '10px solid #91a872ff',
                      }}
                    >
                      <CardContent>
                        <Grid container>
                          <Grid md={3} display='flex' alignItems='center' justifyContent='center'>
                            <img src={Mdplaceholder} alt='doctor' style={{ maxWidth: '60%' }} />
                          </Grid>
                          <Grid md={9} p={2}>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#445e24ff',
                                fontWeight: 'bold',
                              }}
                            >
                              <AccountCircleIcon sx={{ mr: 1 }} />{' '}
                              {/* Add some right margin for spacing */}
                              <Button
                                variant='text'
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: '#445e24ff',
                                  fontWeight: 'bold',
                                  marginLeft: '-8px',
                                }}
                                onClick={() => handleViewProfile(row.md_id, row)}
                              >
                                Name: {row?.name}
                              </Button>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#445e24ff',
                                fontWeight: 'bold',
                              }}
                              mt={1}
                            >
                              <MedicalServicesIcon sx={{ mr: 1 }} />{' '}
                              {/* Add some right margin for spacing */}
                              <Typography
                                variant='button'
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: '#445e24ff',
                                  fontWeight: 'bold',
                                }}
                              >
                                specialty: {row?.specialty}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#445e24ff',
                                fontWeight: 'bold',
                              }}
                              mt={2}
                            >
                              <MapsHomeWorkIcon sx={{ mr: 1 }} />{' '}
                              {/* Add some right margin for spacing */}
                              <Typography
                                variant='button'
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: '#445e24ff',
                                  fontWeight: 'bold',
                                }}
                              >
                                clinic:{' '}
                                {row?.primary_clinic ?? (
                                  <Typography
                                    component='span'
                                    sx={{
                                      fontWeight: 'normal',
                                      fontStyle: 'italic',
                                      color: 'gray',
                                      fontSize: '12px',
                                    }}
                                  >
                                    No Indicated Primary Clinic
                                  </Typography>
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#445e24ff',
                                fontWeight: 'bold',
                              }}
                              mt={2}
                            >
                              <CalendarMonthIcon sx={{ mr: 1 }} />{' '}
                              {/* Add some right margin for spacing */}
                              <Typography
                                variant='button'
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: '#445e24ff',
                                  fontWeight: 'bold',
                                }}
                              >
                                Best Day to Cover:{' '}
                                {row?.best_day_to_cover ?? (
                                  <Typography
                                    component='span'
                                    sx={{
                                      fontWeight: 'normal',
                                      fontStyle: 'italic',
                                      color: 'gray',
                                      fontSize: '12px',
                                    }}
                                  >
                                    No Indicated Best Day to Cover
                                  </Typography>
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#445e24ff',
                                fontWeight: 'bold',
                              }}
                              mt={2}
                            >
                              <ScheduleIcon sx={{ mr: 1 }} />{' '}
                              {/* Add some right margin for spacing */}
                              <Typography
                                variant='button'
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: '#445e24ff',
                                  fontWeight: 'bold',
                                }}
                              >
                                Best Time to Cover:{' '}
                                {row?.clinic_hour ?? (
                                  <Typography
                                    component='span'
                                    sx={{
                                      fontWeight: 'normal',
                                      fontStyle: 'italic',
                                      color: 'gray',
                                      fontSize: '12px',
                                    }}
                                  >
                                    No Indicated Best Time to Cover
                                  </Typography>
                                )}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              <Grid item sm={12} md={12} lg={12} xl={12}>
                <TablePagination
                  component='div'
                  count={mdList.data?.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowPerPage}
                />
              </Grid>
            </>
          ) : (
            ''
          )}
        </Grid>
      )}
    </Box>
  );
}
